export default __webpack_public_path__ + "static/media/gallery8.edbe0268.jpg";